// This package was migrated to eb-ui
export * from '@eb/feature-detection';